import React from 'react';
import { ReactComponent as CheckIcon } from 'new/components/icons/check-filled.svg';
import classes from './TestCustomProcessor.module.scss';

/** A test run's progress/success line; fades out after 7s. */
const StatusMessage = ({ message }: { message: string }) => (
  <div className={classes.infoText} style={{ animation: 'fadeOut 0.5s ease 7s forwards' }}>
    <CheckIcon />
    <span>{message}</span>
  </div>
);

export default StatusMessage;
